import { Modal, Spin } from 'antd';
import bg_home from 'assets/images/bg_home.jpg';
import HeaderMenu from 'components/Header/HeaderMenu';
import { SITE } from 'config/config';
import qs from 'query-string';
import { useEffect, useState } from 'react';
import { getAllSetting } from 'service/base';
import { CONST_SITE, SETTING_KEYS } from 'utils/common/const';
import { twMerge } from 'tailwind-merge';

const RULE_TABS = [
  { key: 'score', label: 'DỰ ĐOÁN TỶ SỐ' },
  { key: 'wc', label: 'DỰ ĐOÁN WORLD CUP' }
];

/** Không tái sử dụng cùng một element ở nhiều section. */
const TimeRangeBlock = () => (
  <p className="text-[#0053df] font-semibold text-[13px] sm:text-[14px] md:text-[15px] leading-relaxed">
    Từ <span className="font-black text-[#0053df]">00:00:00</span> ngày{' '}
    <span className="font-black text-[#0053df]">01/06/2026</span> đến{' '}
    <span className="font-black text-[#0053df]">23:59:59</span> ngày{' '}
    <span className="font-black text-[#0053df]">11/06/2026</span>
  </p>
);

const wcPrizeRows = [
  { category: 'Đội vô địch', vip0: 28, vip1: 58, vip6: 78, vip11: 108, vip16: 168 },
  { category: 'Vua phá lưới', vip0: 58, vip1: 98, vip6: 138, vip11: 188, vip16: 268 },
  { category: 'Cầu thủ xuất sắc', vip0: 28, vip1: 58, vip6: 88, vip11: 138, vip16: 188 },
  { category: 'Đội Châu Á vào sâu nhất', vip0: 28, vip1: 48, vip6: 78, vip11: 108, vip16: 178 },
  {
    category: 'Đội ghi nhiều bàn nhất trong 1 trận',
    vip0: 48,
    vip1: 88,
    vip6: 138,
    vip11: 188,
    vip16: 268
  }
];

/**
 * Thể lệ: WC 2026 + các hạng mục dự đoán + bảng cơ cấu theo hạng mục dự đoán WC.
 * Luôn dùng bản này — không lấy HTML từ CMS để tránh nội dung cũ/thiếu ghi đè.
 */
const WcRuleStatic = () => (
  <div className="rule-wc-static text-[#001226] max-w-[880px] mx-auto">
    <h2 className="text-center font-black uppercase text-[#0053df] tracking-tight text-[16px] sm:text-[18px] md:text-[22px] lg:text-[24px] leading-tight px-1">
      THỂ LỆ CHƯƠNG TRÌNH DỰ ĐOÁN WORLD CUP 2026
    </h2>

    <p className="mt-4 font-bold text-[#001226] text-[14px] sm:text-[15px] md:text-[16px] leading-relaxed">
      ✦ Điều kiện tham gia: Thành viên tham gia dự đoán cần có tổng nạp từ 300 điểm trở lên, tính từ
      ngày hôm trước đến trước thời điểm gửi dự đoán. <br />
      Dưới đây là các hạng mục dự đoán mà bạn không thể bỏ lỡ:
    </p>

    <div className="mt-8 space-y-7 sm:space-y-8 text-[13px] sm:text-[14px] md:text-[15px] leading-[1.6] sm:leading-[1.55] text-left">
      <section>
        <p className="text-[#0053df] font-black text-[14px] sm:text-[15px] md:text-[16px] uppercase tracking-wide">
          1. DỰ ĐOÁN ĐỘI VÔ ĐỊCH
        </p>
        <div className="mt-2">
          <TimeRangeBlock />
        </div>
        <p className="mt-2">
          Hội viên chọn 1 đội duy nhất trong danh sách các đội tuyển chính thức tham dự; kết quả lấy
          theo đội thắng trận chung kết do FIFA công bố (bao gồm hiệp phụ và loạt sút luân lưu).
        </p>
      </section>

      <section>
        <p className="text-[#0053df] font-black text-[14px] sm:text-[15px] md:text-[16px] uppercase tracking-wide">
          2. DỰ ĐOÁN VUA PHÁ LƯỚI
        </p>
        <div className="mt-2">
          <TimeRangeBlock />
        </div>
        <p className="mt-2">
          Dự đoán Vua phá lưới World Cup 2026 tại C168. Hội viên chọn 1 cầu thủ duy nhất trong danh
          sách các cầu thủ chính thức tham dự World Cup. Kết quả lấy theo cầu thủ ghi nhiều bàn
          thắng nhất trong các trận đấu chính thức (bao gồm hiệp phụ, không tính loạt sút luân lưu)
          và theo công bố chính thức của FIFA (trường hợp đồng hạng cũng căn cứ theo kết quả FIFA).
        </p>
      </section>

      <section>
        <p className="text-[#0053df] font-black text-[14px] sm:text-[15px] md:text-[16px] uppercase tracking-wide">
          3. DỰ ĐOÁN CẦU THỦ XUẤT SẮC NHẤT (GOLDEN BALL)
        </p>
        <div className="mt-2">
          <TimeRangeBlock />
        </div>
        <p className="mt-2 font-semibold text-[#001226]">
          Dự đoán Cầu thủ xuất sắc nhất World Cup 2026 (Golden Ball) tại C168.
        </p>
        <p className="mt-2">
          Hội viên chọn 1 cầu thủ duy nhất trong danh sách các cầu thủ chính thức tham dự World Cup.
          Kết quả lấy theo danh hiệu Cầu thủ xuất sắc nhất (Golden Ball) do FIFA công bố chính thức.
        </p>
      </section>

      <section>
        <p className="text-[#0053df] font-black text-[14px] sm:text-[15px] md:text-[16px] uppercase tracking-wide">
          4. DỰ ĐOÁN ĐỘI CHÂU Á VÀO SÂU NHẤT
        </p>
        <div className="mt-2">
          <TimeRangeBlock />
        </div>
        <p>
          Nội dung dự đoán: Dự đoán đội tuyển châu Á có thành tích tiến sâu nhất tại World Cup kỳ
          này. <br /> Lựa chọn dự đoán: Nền tảng chỉ hiển thị các đội tuyển châu Á chính thức tham
          dự World Cup kỳ này, người dùng chọn duy nhất 1 đội <br /> Quy tắc xác định: So sánh theo
          vòng đấu mà đội tuyển dừng chân cuối cùng; nếu có nhiều đội dừng ở cùng một vòng, thì so
          sánh điểm số vòng bảng; nếu điểm số vòng bảng vẫn bằng nhau, thì so sánh hiệu số bàn thắng
          bại vòng bảng. <br />
        </p>
      </section>

      <section>
        <p className="text-[#0053df] font-black text-[14px] sm:text-[15px] md:text-[16px] uppercase tracking-wide">
          5. ĐỘI GHI NHIỀU BÀN NHẤT TRONG 1 TRẬN
        </p>
        <div className="mt-2">
          <TimeRangeBlock />
        </div>
        <p className="mt-2">
          Hội viên chọn 1 đội duy nhất trong danh sách các đội ghi bàn nhiều nhất trong 1 trận đấu
          chính thức của World Cup 2026. Kết quả được xác định theo trận đấu có tổng số bàn thắng
          nhiều nhất trong thời gian thi đấu chính thức và hiệp phụ (không tính loạt sút luân lưu),
          căn cứ theo kết quả công bố chính thức của FIFA. Trường hợp có nhiều trận đấu có cùng số
          bàn thắng cao nhất, kết quả sẽ được xác định theo trận đấu diễn ra sớm nhất trong số các
          trận có cùng số bàn thắng đó.
        </p>
      </section>
    </div>

    <h3 className="mt-10 text-center font-black uppercase text-[#0053df] text-[16px] sm:text-[17px] md:text-[19px] tracking-wide border-b border-[#0053df]/30 pb-3">
      Cơ cấu giải thưởng (theo hạng mục dự đoán WC)
    </h3>

    <div className="mt-4 overflow-x-auto -mx-1 px-1 pb-1">
      <div className="min-w-[720px] rounded-[14px] overflow-hidden border border-[#d8dee6] bg-white shadow-[0_2px_14px_rgba(15,23,42,0.07)] font-bold">
        <div
          className="grid bg-gradient-to-b from-[#4da3ff] via-[#1e7ae8] to-[#0053df] text-white font-bold uppercase tracking-wide text-center text-[11px] sm:text-[12px] md:text-[14px] leading-tight py-4 sm:py-[18px]"
          style={{ gridTemplateColumns: 'minmax(160px,2.1fr) repeat(5, minmax(56px,1fr))' }}
        >
          <div className="px-2 sm:px-3 flex items-center justify-center border-r border-white/25">
            HẠNG MỤC
          </div>
          <div className="flex items-center justify-center border-r border-white/25 px-1">
            VIP 0
          </div>
          <div className="flex items-center justify-center border-r border-white/25 px-1">
            VIP 1+
          </div>
          <div className="flex items-center justify-center border-r border-white/25 px-1">
            VIP 6+
          </div>
          <div className="flex items-center justify-center border-r border-white/25 px-1">
            VIP 11+
          </div>
          <div className="flex items-center justify-center px-1">VIP 16+</div>
        </div>
        {wcPrizeRows.map((row) => (
          <div
            key={row.category}
            className="grid bg-white text-black font-bolt text-[11px] sm:text-[12px] md:text-[14px] leading-snug min-h-[52px]"
            style={{ gridTemplateColumns: 'minmax(160px,2.1fr) repeat(5, minmax(56px,1fr))' }}
          >
            <div className="px-2 sm:px-3 py-3.5 sm:py-4 text-center border-r border-[#e8ecf1] flex items-center justify-center">
              {row.category}
            </div>
            <div className="text-center py-3.5 sm:py-4 border-r border-[#e8ecf1] flex items-center justify-center tabular-nums">
              {row.vip0}
            </div>
            <div className="text-center py-3.5 sm:py-4 border-r border-[#e8ecf1] flex items-center justify-center tabular-nums">
              {row.vip1}
            </div>
            <div className="text-center py-3.5 sm:py-4 border-r border-[#e8ecf1] flex items-center justify-center tabular-nums">
              {row.vip6}
            </div>
            <div className="text-center py-3.5 sm:py-4 border-r border-[#e8ecf1] flex items-center justify-center tabular-nums">
              {row.vip11}
            </div>
            <div className="text-center py-3.5 sm:py-4 flex items-center justify-center tabular-nums">
              {row.vip16}
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export const RuleRoutePage = () => {
  const [ruleTab, setRuleTab] = useState('score');
  const [dataSettings, setDataSettings] = useState([]);
  const [settingsLoading, setSettingsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await getAllSetting(qs.stringify({ site: CONST_SITE.C168 }));
        if (!cancelled) setDataSettings(res?.data || []);
      } catch {
        if (!cancelled) setDataSettings([]);
      } finally {
        if (!cancelled) setSettingsLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const ruleHtml = dataSettings?.find((item) => item.key === SETTING_KEYS.RULE)?.content ?? '';

  return (
    <div className={twMerge(SITE, 'w-full min-h-screen')}>
      <img src={bg_home} alt="" className="h-full w-full fixed right-0 bottom-0 object-cover" />
      <div className="relative z-10 pb-8">
        <HeaderMenu />
        <div className="container relative z-10 max-w-[1000px] mx-auto px-2 pt-2 md:pt-4 sm:px-3 py-4 sm:py-6">
          <div
            className="rounded-2xl border-2 border-[#A6CAFA] bg-white/75 backdrop-blur-md shadow-[0_8px_40px_rgba(0,83,223,0.12)] px-3 py-4 md:px-6 md:py-6"
            style={{
              boxShadow: '0 4px 24px rgba(17,73,160,0.12), inset 0 0 0 1px rgba(255,255,255,0.8)'
            }}
          >
            <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-4 md:mb-5 px-1">
              {RULE_TABS.map((tab) => {
                const active = ruleTab === tab.key;
                return (
                  <button
                    key={tab.key}
                    type="button"
                    onClick={() => setRuleTab(tab.key)}
                    className={twMerge(
                      'rounded-[50px] px-4 md:px-8 py-2 md:py-2.5 text-[10px] sm:text-[11px] md:text-[13px] font-extrabold uppercase tracking-[0.02em] border-2 transition-all duration-200',
                      active
                        ? 'border-[#0053DF] bg-[#0053DF] text-white shadow-[0_3px_10px_rgba(0,83,223,0.35)]'
                        : 'border-[#D9E2EF] bg-white text-[#1E56C7] hover:border-[#A6CAFA]'
                    )}
                  >
                    {tab.label}
                  </button>
                );
              })}
            </div>

            {ruleTab === 'score' ? (
              settingsLoading ? (
                <div className="flex justify-center py-16">
                  <Spin size="large" />
                </div>
              ) : (
                <div className="mx-auto bg-white/95 border-solid border-[#26A9E0] border-[6px] rounded-3xl shadow shadow-primary p-2 md:pb-8 md:pt-4 md:px-10 w-full rule-cms-html">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: ruleHtml
                    }}
                  />
                </div>
              )
            ) : (
              <div className="mx-auto rounded-3xl border-[5px] border-solid border-[#26A9E0]/90 bg-white/90 backdrop-blur-sm shadow-[0_8px_40px_rgba(0,83,223,0.1)] p-4 sm:p-6 md:pb-10 md:pt-8 md:px-8 lg:px-10 w-full">
                <WcRuleStatic />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const RulePage = ({ isModalRule, setIsModalRule }) => {
  const [ruleTab, setRuleTab] = useState('score');
  const [dataSettings, setDataSettings] = useState([]);
  const [settingsLoading, setSettingsLoading] = useState(false);

  useEffect(() => {
    if (!isModalRule) return;
    let cancelled = false;
    setSettingsLoading(true);
    (async () => {
      try {
        const res = await getAllSetting(qs.stringify({ site: CONST_SITE.C168 }));
        if (!cancelled) setDataSettings(res?.data || []);
      } catch {
        if (!cancelled) setDataSettings([]);
      } finally {
        if (!cancelled) setSettingsLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [isModalRule]);

  const handleClose = () => {
    setIsModalRule(false);
  };

  const ruleHtml = dataSettings?.find((item) => item.key === SETTING_KEYS.RULE)?.content ?? '';

  return (
    <Modal
      open={isModalRule}
      onCancel={handleClose}
      footer={null}
      width={1000}
      centered
      className="rule-modal"
    >
      <div className="w-full h-auto max-h-[80vh] overflow-y-auto">
        <div
          className="rounded-2xl border-2 border-[#A6CAFA] bg-white/75 backdrop-blur-md shadow-[0_8px_40px_rgba(0,83,223,0.12)] px-3 py-4 md:px-5 md:py-5"
          style={{
            boxShadow: '0 4px 24px rgba(17,73,160,0.12), inset 0 0 0 1px rgba(255,255,255,0.8)'
          }}
        >
          <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-4 md:mb-4 px-1">
            {RULE_TABS.map((tab) => {
              const active = ruleTab === tab.key;
              return (
                <button
                  key={tab.key}
                  type="button"
                  onClick={() => setRuleTab(tab.key)}
                  className={twMerge(
                    'rounded-[50px] px-4 md:px-6 py-2 md:py-2.5 text-[10px] sm:text-[11px] md:text-[12px] font-extrabold uppercase tracking-[0.02em] border-2 transition-all duration-200',
                    active
                      ? 'border-[#0053DF] bg-[#0053DF] text-white shadow-[0_3px_10px_rgba(0,83,223,0.35)]'
                      : 'border-[#D9E2EF] bg-white text-[#1E56C7] hover:border-[#A6CAFA]'
                  )}
                >
                  {tab.label}
                </button>
              );
            })}
          </div>

          {ruleTab === 'score' ? (
            settingsLoading ? (
              <div className="flex justify-center py-12">
                <Spin size="large" />
              </div>
            ) : (
              <div className="mx-auto bg-white/95 border-solid border-[#26A9E0] border-[6px] rounded-3xl shadow shadow-primary p-2 md:pb-6 md:pt-3 md:px-6 w-full rule-cms-html">
                <div
                  dangerouslySetInnerHTML={{
                    __html: ruleHtml
                  }}
                />
              </div>
            )
          ) : (
            <div className="mx-auto rounded-3xl border-[5px] border-solid border-[#26A9E0]/90 bg-white/90 backdrop-blur-sm shadow-[0_8px_40px_rgba(0,83,223,0.1)] p-4 sm:p-6 md:pb-10 md:pt-8 md:px-8 lg:px-10 w-full">
              <WcRuleStatic />
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default RulePage;
